import { render, staticRenderFns } from "./rfUser.vue?vue&type=template&id=2a68c8ce&"
import script from "./rfUser.vue?vue&type=script&lang=js&"
export * from "./rfUser.vue?vue&type=script&lang=js&"
import style0 from "./rfUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports